import React, { FC } from 'react';
import styled from 'styled-components';

const StyledDivider = styled.div`
	position: absolute;
	top: 0;
	display: flex;
	align-items: center;
	justify-content: space-evenly;
	width: 100%;
`;

const Dot = styled.div`
	height: 4px;
	width: 2px;
	background: ${({ theme }) => theme.colors.bg1};
`;

export const Divider: FC = () => {
	return (
		<StyledDivider>
			<Dot />
			<Dot />
			<Dot />
			<Dot />
		</StyledDivider>
	);
};
